module.exports = __webpack_public_path__ + "img/bootcut.3a50b731.png";